
import { Component, Vue, Prop } from 'vue-property-decorator';
import ChartHeading from '@/components/DataTab/Charts/ChartComponents/ChartHeading.vue';
import TimelineChart from '@/components/DataTab/Charts/ChartComponents/TimelineSummaryCharts/TimelineChart.vue';
import BoxChart from '@/components/DataTab/Charts/ChartComponents/TimelineSummaryCharts/BoxChart.vue';
import {
  ChartLoadingStatus,
  ScenarioNameType,
  SummaryFormattedType,
  TimelineFormattedType,
} from '@/types';

@Component({
  components: { BoxChart, ChartHeading, TimelineChart },
})
export default class TimelineSummaryContainer extends Vue {
  @Prop() readonly areaId!: number;
  @Prop() readonly groupId!: number;
  @Prop() readonly lineChartId!: number; // timeline
  @Prop() readonly boxPlotChartId!: number; // summary
  @Prop() readonly timelineData!: TimelineFormattedType[];
  @Prop() readonly timelineDataStatus!: ChartLoadingStatus;
  @Prop() readonly summaryData!: SummaryFormattedType[];
  @Prop() readonly summaryDataStatus!: ChartLoadingStatus;
  @Prop({ type: Boolean, default: false }) readonly showTooltip!: boolean;

  chartSelection: 'timeline' | 'summary' = 'timeline';

  get chartId(): number {
    return this.chartSelection === 'timeline'
      ? this.lineChartId
      : this.boxPlotChartId;
  }

  get description() {
    return this.$t(`data.chartTables.${this.chartId}.description`);
  }

  get scenarioList(): ScenarioNameType[] {
    return this.$store.getters.selectedScenarioList;
  }
}
